{
  "hub": {
    "title": "系列大全 | 卡牌拍賣分類 — BidNova",
    "description": "按遊戲、評級、角色、語言及形式瀏覽BidNova Auctions精選卡牌拍賣系列。",
    "h1": "系列大全",
    "intro": "探索精選的即時卡牌拍賣系列，按遊戲、評級、角色、語言及形式分類。",
    "kinds": {
      "game": "按遊戲",
      "grade": "按評級",
      "character": "按角色",
      "language": "按語言",
      "format": "按形式"
    }
  },
  "common": {
    "breadcrumbHome": "首頁",
    "breadcrumbAuctions": "拍賣",
    "breadcrumbCollections": "系列大全",
    "relatedLabel": "相關系列",
    "faqLabel": "常見問題",
    "browseAllCta": "查看所有相關商品",
    "emptyState": "目前暫無{label}即時拍賣。新商品會於日間持續上架 — 可瀏覽所有拍賣或稍後再查看。",
    "whyBuyTitle": "為何選擇BidNova",
    "whyBuyBody": "BidNova是於英國註冊的市場平台。每件商品均由具公開評分的經核實賣家出售，以英鎊定價，並透過Stripe付款。款項會保留至你確認收到與描述相符的商品為止。",
    "whyBuyPoint1": "Stripe安全付款，附買家保障。",
    "whyBuyPoint2": "經核實英國賣家，具公開評分及爭議處理機制。",
    "whyBuyPoint3": "以英鎊定價 — 無隱藏兌換費用。",
    "sellingTitle": "想出售{label}嗎？",
    "sellingBody": "獲批准的賣家可於同一控制台上架單卡、未拆封商品及其他卡牌。只需加上相片、鑑定資料及起標價格，數分鐘內即可上架。",
    "sellCta": "立即開店"
  },
  "pokemonAuctions": {
    "title": "寶可夢卡牌拍賣 — 英國即時競投 | BidNova",
    "description": "參與英國寶可夢卡牌即時拍賣，鑑定卡與生卡皆有，Stripe安全付款，賣家經核實，價格以英鎊計算。",
    "intro": "探索寶可夢卡牌的英國即時拍賣，由普通生卡到PSA、BGS鑑定的搶手卡應有盡有。所有商品均由經核實賣家出售，以英鎊定價，並受Stripe安全付款保障。"
  },
  "onePieceAuctions": {
    "title": "航海王卡牌遊戲拍賣 | BidNova",
    "description": "英國即時拍賣航海王卡牌遊戲單卡及未拆封商品，英文版及日文版、生卡及鑑定卡齊備。",
    "intro": "瀏覽航海王卡牌遊戲的即時拍賣 — 英文版及日文版單卡、異畫稀有卡及未拆封盒裝，由生卡到PSA、BGS、CGC鑑定卡一應俱全。"
  },
  "yugiohAuctions": {
    "title": "遊戲王卡牌拍賣 | BidNova",
    "description": "英國遊戲王卡牌即時拍賣 — 復古及現代單卡，鑑定卡與生卡、英文版及日文版皆有。",
    "intro": "選購遊戲王即時拍賣，由復古初版經典卡到現代主力卡，經核實英國賣家提供生卡及專業鑑定卡。"
  },
  "psa10Cards": {
    "title": "PSA 10 完美卡牌拍賣 | BidNova",
    "description": "橫跨寶可夢、航海王、體育卡等多個系列的PSA 10完美評級卡即時拍賣。",
    "intro": "PSA 10完美評級代表卡牌居中、卡面及卡角狀態的最高境界。瀏覽涵蓋各大卡牌遊戲的即時拍賣，每件商品均附PSA證書編號供核實。"
  },
  "bgsBlackLabel": {
    "title": "BGS Black Label 10 拍賣 | BidNova",
    "description": "極為罕見的BGS Black Label 10卡牌即時拍賣 — 四項細評分數全數滿分。",
    "intro": "BGS Black Label是Beckett授予的最稀有評級 — 居中、卡角、卡邊及卡面四項細評均為滿分10分。瀏覽經核實英國賣家提供的Black Label即時拍賣。"
  },
  "cgcPristine": {
    "q1": "什麼是CGC Pristine 10？",
    "a1": "Pristine 10是CGC最高評級，只授予居中、卡面、卡角及卡邊近乎完美的卡牌。",
    "q2": "CGC Pristine 10與PSA 10相同嗎？",
    "a2": "兩者採用不同評分標準 — CGC Pristine 10一般被視為與PSA 10相若甚至更嚴格。",
    "q3": "哪些系列常見CGC鑑定？",
    "a3": "CGC鑑定的範圍包括卡牌、漫畫、漫畫書及未拆封商品，涵蓋寶可夢、航海王、體育卡等。",
    "q4": "可以核實CGC證書嗎？",
    "a4": "可以，商品附有CGC證書編號，可於CGC官網查詢。"
  },
  "charizard": {
    "q1": "為什麼噴火龍如此受收藏家歡迎？",
    "a1": "噴火龍自初代Base Set起已是粉絲最愛的寶可夢，長期帶動強勁的收藏需求。",
    "q2": "有鑑定過的噴火龍卡牌嗎？",
    "a2": "有，PSA、BGS及CGC鑑定的噴火龍卡牌與生卡一同上架，涵蓋多個系列。",
    "q3": "可以找到日文版噴火龍卡牌嗎？",
    "a3": "可以，按卡牌語言篩選即可找到日文版噴火龍卡牌。",
    "q4": "有復古Base Set噴火龍卡牌嗎？",
    "a4": "復古及現代噴火龍卡牌均有上架 — 請查看商品詳情了解系列及版次。"
  },
  "pikachu": {
    "q1": "皮卡丘卡牌為何具收藏價值？",
    "a1": "作為寶可夢的代表角色，皮卡丘擁有無數宣傳版、繪師版及特別版印刷，深受收藏家追捧。",
    "q2": "有繪師版（Illustrator）皮卡丘宣傳卡嗎？",
    "a2": "罕見的皮卡丘宣傳卡偶爾會出現 — 請查看現有商品並設定搜尋通知。",
    "q3": "可以找到鑑定過的皮卡丘卡牌嗎？",
    "a3": "可以，PSA、BGS及CGC鑑定的皮卡丘卡牌與生卡一同提供。",
    "q4": "有日文版皮卡丘卡牌嗎？",
    "a4": "有，按卡牌語言篩選即可找到日文版皮卡丘卡牌。"
  },
  "umbreon": {
    "q1": "為什麼月亮伊布卡牌如此搶手？",
    "a1": "月亮伊布的伊布家族畫作，尤其是Gold Star及VMAX異畫版本，深受收藏家珍視。",
    "q2": "有鑑定過的月亮伊布卡牌嗎？",
    "a2": "有，PSA、BGS及CGC鑑定的月亮伊布卡牌與生卡一同上架。",
    "q3": "可以找到月亮伊布VMAX異畫卡嗎？",
    "a3": "異畫及隱藏稀有的月亮伊布卡牌會在有貨時出現 — 請查看現有即時商品。",
    "q4": "有日文版月亮伊布卡牌嗎？",
    "a4": "有，按卡牌語言篩選即可找到日文版月亮伊布卡牌。"
  },
  "luffy": {
    "q1": "哪些系列有路飛卡牌？",
    "a1": "路飛在多個航海王卡牌遊戲系列中以領袖卡及角色卡形式登場，包括備受追捧的異畫版本。",
    "q2": "有鑑定過的路飛卡牌嗎？",
    "a2": "有，PSA、BGS及CGC鑑定的路飛卡牌與生卡一同上架。",
    "q3": "可以找到日文版路飛卡牌嗎？",
    "a3": "可以，按卡牌語言篩選即可找到日文版路飛卡牌。",
    "q4": "有漫畫風格的路飛卡牌嗎？",
    "a4": "偶爾會出現以路飛為主角的漫畫風格平行卡 — 亦可查看我們的漫畫卡系列。"
  },
  "mangaCards": {
    "title": "漫畫畫風卡牌拍賣 | BidNova",
    "description": "英國漫畫風格平行卡即時拍賣，以航海王卡牌遊戲為主。",
    "intro": "漫畫卡是採用黑白漫畫畫風的低機率平行版本，主要見於航海王卡牌遊戲。瀏覽經核實英國賣家提供的漫畫畫風即時拍賣。"
  },
  "japaneseCards": {
    "title": "日版卡牌拍賣 | BidNova",
    "description": "英國日版寶可夢、航海王及遊戲王卡牌即時拍賣，生卡及鑑定卡皆有。",
    "intro": "日版卡牌因採用優質卡紙、較早推出及獨特畫作而備受珍視。瀏覽涵蓋各大卡牌遊戲的日文版卡牌即時拍賣。"
  },
  "englishCards": {
    "title": "英版卡牌拍賣 | BidNova",
    "description": "英國英文版卡牌即時拍賣，橫跨寶可夢、航海王、遊戲王等多個系列。",
    "intro": "英文版卡牌佔BidNova大部分即時商品，涵蓋單卡、未拆封商品及各大鑑定公司。瀏覽經核實英國賣家提供的完整商品。"
  },
  "pokemon": {
    "q1": "這些寶可夢卡牌是正版嗎？",
    "a1": "每件商品均由經核實英國賣家出售，鑑定卡附有PSA、BGS或CGC證書資料（如適用）。",
    "q2": "可以買到未鑑定（生卡）的寶可夢卡嗎？",
    "a2": "可以 — 生卡及專業鑑定卡皆有上架，可按鑑定公司及評分篩選。",
    "q3": "接受什麼付款方式？",
    "a3": "所有拍賣均以英鎊定價，並透過Stripe安全付款，款項會保留至你確認收貨為止。",
    "q4": "有出售未拆封的寶可夢商品嗎？",
    "a4": "有，未拆封的補充包盒、包裝及鐵盒與單卡一同上架 — 可在瀏覽頁使用商品類型篩選。"
  },
  "onePiece": {
    "q1": "什麼是航海王卡牌遊戲？",
    "a1": "由Bandai推出、以航海王漫畫及動畫為題材的卡牌遊戲，深受全球收藏家喜愛。",
    "q2": "英文版及日文版航海王卡牌都有嗎？",
    "a2": "有 — 可按卡牌語言篩選，尋找英文版或日文版航海王卡牌。",
    "q3": "可以特別搜尋路飛的卡嗎？",
    "a3": "可以，請查看我們專屬的路飛系列，內有角色專屬商品。",
    "q4": "有鑑定過的航海王卡牌嗎？",
    "a4": "有，PSA、BGS及CGC鑑定的航海王卡牌與生卡一同上架。"
  },
  "yugioh": {
    "q1": "有復古遊戲王卡牌嗎？",
    "a1": "有，復古及現代遊戲王單卡均有上架，包括初版及限定版卡牌。",
    "q2": "遊戲王卡牌有鑑定嗎？",
    "a2": "許多商品已由PSA、BGS或CGC專業鑑定；亦有生卡供選擇。",
    "q3": "可以買到日文版遊戲王卡牌嗎？",
    "a3": "可以，按卡牌語言篩選即可找到日文版遊戲王卡牌。",
    "q4": "有一口價購買選項嗎？",
    "a4": "許多賣家在即時競投之外同時提供一口價，留意商品上的一口價標籤。"
  },
  "psa10": {
    "q1": "PSA 10代表什麼？",
    "a1": "PSA 10（完美評級）是Professional Sports Authenticator頒發的最高評級，代表卡牌近乎完美無瑕。",
    "q2": "可以核實PSA證書嗎？",
    "a2": "可以，PSA鑑定商品附有證書編號，可在PSA官網獨立核實。",
    "q3": "哪些系列有PSA 10商品？",
    "a3": "PSA 10卡牌涵蓋寶可夢、航海王、遊戲王、體育卡等 — 可使用瀏覽篩選按系列縮小範圍。",
    "q4": "PSA 10卡牌會較昂貴嗎？",
    "a4": "完美評級因稀有及外觀出眾，通常較低評級卡牌有更高溢價。"
  },
  "bgsBlack": {
    "q1": "什麼是BGS Black Label？",
    "a1": "Black Label是Beckett授予的最稀有評級 — 四項細評（居中、卡角、卡邊、卡面）全數滿分10分。",
    "q2": "Black Label卡牌有多罕見？",
    "a2": "極為罕見 — 大部分系列的鑑定總數中，Black Label例子只有寥寥數張。",
    "q3": "可以核實BGS證書嗎？",
    "a3": "可以，BGS鑑定商品附有證書編號，可在Beckett官網核實各項細評。",
    "q4": "Black Label卡牌會有溢價嗎？",
    "a4": "會，由於極為稀有，Black Label卡牌通常較一般BGS 10有顯著溢價。"
  },
  "manga": {
    "q1": "什麼是漫畫卡？",
    "a1": "漫畫卡是採用黑白或漫畫風格畫作的平行版本，而非標準插畫，常見於航海王及其他卡牌遊戲。",
    "q2": "哪些遊戲有漫畫畫風卡牌？",
    "a2": "航海王卡牌遊戲以漫畫稀有卡最為知名，其他遊戲亦偶爾推出類似平行版本。",
    "q3": "漫畫卡有鑑定嗎？",
    "a3": "有，鑑定卡及生卡均有上架 — 可按鑑定公司篩選縮小範圍。",
    "q4": "漫畫卡比標準版更稀有嗎？",
    "a4": "漫畫稀有卡通常屬於較低機率的平行版本，因此較標準稀有度更為稀缺。"
  },
  "japanese": {
    "q1": "為什麼收藏家偏好日版卡牌？",
    "a1": "日版卡牌通常採用較優質卡紙、較早推出，並具備獨特的畫作變化。",
    "q2": "日版卡牌的鑑定方式相同嗎？",
    "a2": "是的，PSA、BGS及CGC均以與英文版相同的標準鑑定日文版卡牌。",
    "q3": "哪些系列有日版商品？",
    "a3": "寶可夢、航海王及遊戲王均有活躍的日版商品 — 可使用系列篩選瀏覽。",
    "q4": "日版卡牌會比英版貴嗎？",
    "a4": "價格主要視乎稀有度及狀態而非語言，惟部分日版限定版本可能有溢價。"
  },
  "english": {
    "q1": "大部分商品是英文版嗎？",
    "a1": "英文版卡牌佔寶可夢、航海王、遊戲王及體育卡商品的大多數。",
    "q2": "英文版卡牌有鑑定嗎？",
    "a2": "有，PSA、BGS、CGC及其他鑑定公司均有代表，亦有未鑑定的生卡。",
    "q3": "可以按系列及版次篩選嗎？",
    "a3": "可以，於瀏覽頁使用系列、版次（初版／普通版）及卡面（亮面／反亮面）篩選。",
    "q4": "有英文版未拆封商品嗎？",
    "a4": "有，英文版補充包盒及包裝與單卡一同上架。"
  }
}
